export function serverFormatDate(date: Date) {
  const lengthOfDate = 2;
  const dd = String(date.getDate()).padStart(lengthOfDate, '0');
  const mm = String(date.getMonth() + 1).padStart(lengthOfDate, '0'); // January is 0
  const yyyy = date.getFullYear();

  return `${yyyy}-${mm}-${dd}`;
}
